<h1 mat-dialog-title>{{'protocolEdit.responsibilities.title' | translate}}</h1>

<div mat-dialog-content [class]="getTheme()">

  <div fxLayout="column" fxLayout.xs="column" class="flexwrap">
    <div fxFlex="100">
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'protocolEdit.responsibilities.action.label' | translate }}</mat-label>
        <input matInput [(ngModel)]="data.responsibility.action" required [disabled]="data.disabled"
          [ngModelOptions]="{standalone: true}">
        <mat-error>
          {{ 'executionEdit.referenceDocs.code.error' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
    <div fxFlex="100">
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'protocolEdit.responsibilities.responsible.label' | translate }}</mat-label>
        <input matInput [(ngModel)]="data.responsibility.responsible" [disabled]="data.disabled" [ngModelOptions]="{standalone: true}">
      </mat-form-field>
    </div>
  </div>

</div>

<div mat-dialog-actions align="end" [class]="getTheme()">
  @if (!data.disabled) {
    <button mat-raised-button color="primary" (click)="onOkClick()">
    {{ 'button.save' | translate }}</button>
  }
  <button mat-raised-button color="secondary" (click)="onNoClick()">
  {{ 'button.cancel' | translate }}</button>
</div>